// ResetPasswordPage.jsx
// Place this file in your React app (e.g. src/pages/ResetPasswordPage.jsx)
// Usage: add a route for path="/resetpassword" that renders this component.
// Example: <Route path="/resetpassword" element={<ResetPasswordPage/>} />

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { API_BASE_URL, ENDPOINTS } from '../../config';
import { Notyf } from "notyf";
const notyf = new Notyf({
    position: { x: "right", y: "top" },
    ripple: true,
    dismissible: true,
});
// Edit this if your API base is different
const API_BASE = API_BASE_URL || "https://ai.holaai.in";

export default function ForgetPasswordPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const [token, setToken] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const t = params.get("token") || "";
        if (t) setToken(t);
    }, [location.search]);

    function validate() {

        if (!token) return notyf.error("Reset token is required. Paste it or open the link from your email.");
        if (!newPassword || newPassword.length < 8) return notyf.error("Password must be at least 8 characters.");
        if (newPassword !== confirmPassword) return notyf.error("Passwords do not match.");
        return true;
    }

    async function handleSubmit(e) {
        e.preventDefault();

        if (!validate()) return;
        setLoading(true);
        try {
            const res = await fetch(`${API_BASE}/auth/reset-password`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token: token.trim(), new_password: newPassword }),
            });

            const data = await res.json();
            if (!res.ok) {
                const detail = data.detail || data.message || "Failed to reset password";
                notyf.error(detail);
                setLoading(false);
                return;
            }

            notyf.success(data.message || "Password has been reset successfully.");

            setLoading(false);
            // auto-redirect to login after 3 seconds
            setTimeout(() => navigate("/", { replace: true }), 3000);
        } catch (err) {
            notyf.error("Network error. Please try again later.");
            setLoading(false);
        }
    }

    return (
        <div className="auth-body login">
            <div className="auth-background">
                <div className="bg-pattern"></div>
                <div className="floating-elements">
                    <div className="floating-element"><i className="fas fa-brain"></i></div>
                    <div className="floating-element"><i className="fas fa-robot"></i></div>
                    <div className="floating-element"><i className="fas fa-chart-line"></i></div>
                    <div className="floating-element"><i className="fas fa-image"></i></div>
                </div>
            </div>
            <div className="auth-container">
                <div className="auth-card">
                    <div className="auth-header">
                        <div className="brand-logo">
                            <h1><img src="assets/img/hola.png" alt="" className="logo" /></h1>
                        </div>
                        <p><strong>Forgot Your Password?</strong></p>
                        <p>Enter your registered email address and we’ll send you a password reset link. Please check your inbox and follow the instructions.</p>
                    </div>
                    <form className="auth-login-form" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <div className="form-group">
                                <div className="input-group">
                                    <span className="input-group-text">
                                        <i className="fas fa-envelope"></i>
                                    </span>
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder="Enter your email"
                                        required
                                        autoComplete="off"
                                    />
                                </div>
                            </div>
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="btn btn-primary btn-auth"
                        >
                            {loading ? (
                                <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                                </svg>
                            ) : null}
                            Reset password
                        </button>
                        <a href="/" className="btn btn-warning btn-auth">Back to login</a>
                    </form>
                </div>
            </div>
        </div>
    );
}
